module.exports = __webpack_public_path__ + "img/cloud4.3f00aaea.png";